import { render } from "./TelegramConfig.vue?vue&type=template&id=7a01956e"
import script from "./TelegramConfig.vue?vue&type=script&lang=js"
export * from "./TelegramConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__